var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPinStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.678 10.778a1 1 0 0 1-1.415 0L14.9 16.142v2.207a1.5 1.5 0 0 1-.439 1.06l-.914.915a1.5 1.5 0 0 1-2.121 0l-3.182-3.182-3.536 3.536a1 1 0 0 1-1.414-1.414l3.535-3.536-3.182-3.182a1.5 1.5 0 0 1 0-2.121l.915-.915a1.5 1.5 0 0 1 1.06-.439h2.207l5.364-5.364a1 1 0 0 1 1.415-1.414l7.07 7.071a1 1 0 0 1 0 1.414m-13.021.293 5.95-5.95 4.242 4.243-5.95 5.95v2.828l-.414.414-7.07-7.07.413-.415z",
  clipRule: "evenodd"
})));
export default SvgIcPinStroke;